import { useI18n } from "@/i18n";
import { Button } from "@/components/ui/button";
import { Languages } from "lucide-react";

export default function LanguageToggle({ onDark = false }) {
  const { lang, toggle } = useI18n();
  return (
    <Button
      variant="outline"
      size="sm"
      data-testid="language-toggle"
      onClick={toggle}
      className={`rounded-full font-bold ${
        onDark
          ? "bg-white/10 text-white border-white/30 hover:bg-white/20 hover:text-white"
          : "border-border hover:border-secondary"
      }`}
      title="ES / EN"
    >
      <Languages className="h-4 w-4 mr-1" />
      {lang === "es" ? "ES" : "EN"}
    </Button>
  );
}
